<template>
  <div class="text-center text-primary text-weight-bold" style="font-size: 2.75rem">
    Real-time data & analytics for your portfolio
  </div>
  <div class="text-center text-grey-7 q-mb-xl text-subtitle1">
    Leverage daily data and insights from more than 5 million multifamily properties and gain an
    edge on your competition
  </div>
  <div class="q-gutter-y-xl q-mt-xl">
    <div class="row justify-center q-gutter-md">
      <dashboard-card
        icon="bolt"
        title="Regional Reports Add-On"
        color="primary"
        :to="{ name: 'Subscribe to Regional Reports' }"
        action-label="Review Add-On"
        style="max-width: 416px; width: 100%"
      >
        <div class="q-mb-xl" style="height: 405px">
          <div class="row">
            <div class="text-h3">$100</div>
            <div class="q-mt-auto text-subtitle1">/mo</div>
          </div>
          <div class="q-mb-sm text-subtitle2">Best for individuals or small teams</div>
          <div class="q-mt-md" style="height: 84px">
            Power your market surveys with
            <b>real-time data on over 35M multifamily units</b> nationwide, sourced entirely from
            property websites and public data sources.
          </div>
          <q-separator class="q-my-md" />
          <div class="q-my-lg q-gutter-xs">
            <div v-for="(f, index) in features" :key="index">
              <span @mouseover="mouseover(f.label)" @mouseleave="mouseleave(f.label)">
                <q-icon name="check" class="q-mr-sm" />
                <span>{{ f.label }}</span>
                <q-icon name="info_outline" class="q-ml-xs" />
              </span>
              <q-menu :ref="String(f.label)" style="width: 250px" transition-duration="100">
                <q-banner> {{ f.extra }} </q-banner>
              </q-menu>
            </div>
          </div>
          <q-table
            dense
            :rows="rows"
            :columns="[
              {
                field: 'name',
                name: 'name',
                label: 'Name',
                sortable: true,
                align: 'left'
              }
            ]"
            flat
            bordered
            hide-bottom
            hide-header
          >
            <template #body="props">
              <q-tr :props="props" @dblclick="$router.push({ name: props.row.name })">
                <q-td v-for="(col, colIndex) in props.cols" :key="col.name" :props="props">
                  <router-link
                    v-if="colIndex === 0"
                    :to="{ name: props.row.name }"
                    class="text-primary"
                  >
                    {{ col.value }}
                  </router-link>
                  <template v-else>
                    {{ col.value }}
                  </template>
                </q-td>
                <q-td style="text-align: right">
                  <q-btn
                    :id="`intercom-launch-report-${props.rowIndex}`"
                    no-caps
                    unelevated
                    flat
                    color="primary"
                    :to="{ name: props.row.name }"
                  >
                    Try it out!
                  </q-btn>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </dashboard-card>
    </div>
  </div>
</template>
<script lang="ts">
import DashboardCard from '@/components/DashboardCard.vue'
import { marketReportSamples } from 'common'
import type { QPopupProxy } from 'quasar'

export default {
  name: 'PropertyReportsNotSubscribed',
  components: { DashboardCard },
  data() {
    return {
      rows: marketReportSamples,
      features: [
        {
          label: '100% Public Data',
          extra: 'Every data point included is collected from public sources.'
        },
        {
          label: 'Unlimited Reports',
          extra:
            'No limits on the number of markets you can analyze. Scale your real estate portfolio without constraints.'
        },
        {
          label: 'Market Trend Analysis',
          extra:
            'Identify emerging trends with in-depth analysis of historical data to stay ahead of the market.'
        },
        {
          label: 'Regional & National Comparisons',
          extra:
            'Compare property performance across various regions and national averages to make informed investment decisions.'
        },
        {
          label: 'Investment Risk Analysis',
          extra:
            'Assess potential risks associated with your investments by analyzing market volatility, historical performance, and other critical factors.'
        },
        {
          label: 'Advanced Filtering Options',
          extra:
            'Drill down into data with advanced filters to focus on specific property types, regions, and timeframes.'
        }
      ]
    }
  },
  methods: {
    mouseover(label: string) {
      const el = this.$refs[label] as QPopupProxy[]
      if (el) {
        el[0].show()
      }
    },
    mouseleave(label: string) {
      const el = this.$refs[label] as QPopupProxy[]
      if (el) {
        el[0].hide()
      }
    }
  }
}
</script>
